// Altura do header fixo (~72px) + folga, para o alvo não ficar escondido atrás dele.
export const HEADER_OFFSET = 88;

/**
 * Rola suavemente até a seção com o id informado, compensando o header fixo.
 * Retorna true se a seção existe na página atual, false caso contrário.
 */
export function scrollToSection(id, { smooth = true } = {}) {
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;

  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top, behavior: smooth ? "smooth" : "auto" });
  return true;
}
